import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=762db060"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__